import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ScrollToTop from "../../ScrollToTop"

function Product() {
  const [myData, setMyData] = useState([]);
  const [isError, setIsError] = useState("");

 
  const getMyProductData = async () => {
    try {
      const response = await fetch("/db.json"); // Assuming db.json is in the public folder
      if (response.ok) {
        const data = await response.json();
        console.log(data,'data');
        setMyData(data.posts);
      } else {
        throw new Error("Error loading JSON data");
      }
    } catch (error) {
      setIsError(error.message);
    }
  };

  const navigate = useNavigate();

  const productNavigate = (id) => {
    navigate("/product/"+id);
  };

  useEffect(() => {
    getMyProductData();
  }, []);

  return (
    <>
     <ScrollToTop />
      <div className="aon-page-benner-area2">
        <div className="aon-page-banner-row2">
          <div className="aon-page-benner-overlay2" />
          <div className="sf-banner-heading-wrap2">
            <div className="sf-banner-heading-area2">
              <div className="sf-banner-breadcrumbs-nav2">
                <ul className="list-inline">
                  <li>
                    <a href="/"> Home </a>
                  </li>
                  <li>Product</li>
                </ul>
              </div>
              <div className="sf-banner-heading-large2">Our Products</div>
            </div>
            {/* <div className="sf-banner-vid-section">
              <div className="video-play-btn2">
                <a
                  className="mfp-video"
                  href="https://www.youtube.com/watch?v=c1XNqw2gSbU"
                >
                  <i className="fa fa-play" />
                </a>
                <span>
                  Watch Now <br />
                  Companey Details
                </span>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      <div className="aon-shop-wrap">
        <div className="site-top-line" />
        <div className="container">
          {/* <div className="product-filter-wrap d-flex justify-content-between align-items-center">
            <div className="product-filter-left d-flex">
              <button className="shop-list-btn m-r10">
                <i className="feather-grid" />
              </button>
              <button className="shop-list-btn m-r10">
                <i className="feather-list" />
              </button>
              <form
                className="woocommerce-ordering select-box-border-style1-wrapper"
                method="get"
              >
                <select
                  className="form-select"
                  aria-label="Default select example"
                >
                  <option value="menu_order">Default sorting</option>
                  <option value="popularity">Sort by popularity</option>
                  <option value="rating">Sort by average rating</option>
                  <option value="date">Sort by latest</option>
                  <option value="price">Sort by price: low to high</option>
                  <option value="price-desc">Sort by price: high to low</option>
                </select>
              </form>
            </div>
            <div className="product-filter-right d-flex align-items-center">
              <span className="woocommerce-result-count">
                Milcandy <span>25, 316, 00</span> Products Available.
              </span>
              <div className="aon-pro-search ">
                <input
                  className="form-control sf-form-control"
                  name="company_name"
                  type="text"
                  placeholder="Search"
                />
                <button className="pro-search-btn">
                  <i className="fs-input-icon feather-search" />
                </button>
              </div>
            </div>
          </div> */}
          <div className="product-listing-area">
            <div className="row">
              {myData.map((data, index) => {
                return (
                  <span
                    className="col-lg-3 col-md-6 Allproduct"
                    onClick={() => productNavigate(data.id)}
                  >
                    <div className="aon-shop-box">
                      <div className="aon-shop-pic">
                        <img src={data.image} alt="" />
                      </div>
                      <h4 className="aon-shop-title">{data.title}</h4>
                      {/* <p className="aon-shop-text">
                        There are many variations of passages Lorem.
                      </p> */}
                      {/* <div className="aon-shop-bot d-flex">
                        <div className="aon-shop-price">$29.00</div>
                        <div className="aon-shop-add-to d-flex">
                          <button className="aon-shop-btn" type="button">
                            <i className="fa fa-heart" />
                          </button>
                          <button className="aon-shop-btn" type="button">
                            <i className="fa fa-cart-plus" />
                          </button>
                        </div>
                      </div> */}
                    </div>
                  </span>
                );
              })}

              {/* <div className="aon-paging-control">
                <div className="site-pagination2">
                  <ul className="pagination">
                    <li className="page-item">
                      <a className="page-link" href="#">
                        01
                      </a>
                    </li>
                    <li className="page-item active">
                      <a className="page-link" href="#">
                        02
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#">
                        03
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#">
                        04
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="aon-paging-arrow">
                  <div className="aon-paging-arrow-inner">
                    <button type="button">
                      <i className="flaticon-left-arrow" />
                    </button>
                    <button type="button">
                      <i className="flaticon-right-arrows" />
                    </button>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      <section className="aon-add-area">
        <div className="container">
          <div className="section-content">
            <img src="images/add-one.png" alt="" />
          </div>
        </div>
        <div className="site-bot-line" />
      </section>
    </>
  );
}

export default Product;
